import { announcements } from "../state/announcer";
import { useStore } from "../state/store";

/**
 * 読み上げ用の場所（見えない）。操作の結果と、接続の変化をここに流す。
 * 同じ文が続いても読まれるよう、id ごとに要素を作り直す
 */
export function LiveRegion() {
  const { polite, assertive } = useStore(announcements);
  return (
    <div className="visually-hidden">
      <div role="status" aria-live="polite" aria-atomic="true">
        {polite && <span key={polite.id}>{polite.text}</span>}
      </div>
      <div role="alert" aria-live="assertive" aria-atomic="true">
        {assertive && <span key={assertive.id}>{assertive.text}</span>}
      </div>
    </div>
  );
}
